import { useEffect, useState, useRef } from "react";
import api from "@/lib/api";
import { Bell, CheckCheck } from "lucide-react";

export function NotificationBell() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => {
    api.get("/notifications").then(({ data }) => {
      setItems(data.notifications);
      setUnread(data.unread);
    }).catch(() => {});
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 45000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next) load();
  };

  const markAll = () => {
    api.post("/notifications/read-all")
      .then(() => { setUnread(0); setItems((prev) => prev.map((n) => ({ ...n, read: true }))); })
      .catch(() => {});
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid="notification-bell"
        className="relative p-2 rounded-md text-slate-600 hover:bg-slate-100 transition-colors">
        <Bell className="w-5 h-5" />
        {unread > 0 && (
          <span data-testid="notification-badge"
            className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#F5C32C] text-[#0B2447] text-[10px] font-bold flex items-center justify-center">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-panel"
          className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-white border border-slate-200 rounded-xl shadow-2xl z-50">
          <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
            <span className="font-semibold text-[#0B2447] text-sm">Notifications</span>
            <button onClick={markAll} data-testid="notification-mark-all"
              className="flex items-center gap-1 text-xs text-slate-500 hover:text-[#0B2447] transition-colors">
              <CheckCheck className="w-4 h-4" /> Mark all read
            </button>
          </div>
          {items.length === 0 ? (
            <div className="px-4 py-8 text-center text-sm text-slate-400">No notifications yet.</div>
          ) : (
            items.map((n) => (
              <div key={n.id} data-testid="notification-item"
                className={`px-4 py-3 border-b border-slate-50 ${n.read ? "" : "bg-[#F5C32C]/[0.06]"}`}>
                <div className="text-sm font-semibold text-[#0B2447]">{n.title}</div>
                <div className="text-xs text-slate-500 mt-0.5">{n.message}</div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
